import Api from '..'
import {
  OrderInstance,
  OrderCollectionItem
} from './types'

export default class OrdersApi extends Api {
  public endpoint = '/orders'

  public async getOrderCollection (
    status: OrderInstance['status'] | null = null
  ): Promise<OrderCollectionItem[]> {
    const response = await this.http.get(this.endpoint, {
      params: { status: status }
    })
    const responseData: OrderCollectionItem[] = response.data
    return responseData
  }

  public async getOrderInstance (uuid: string): Promise<OrderInstance> {
    const response = await this.http.get(`${this.endpoint}/${uuid}`)
    const responseData: OrderInstance = response.data
    return responseData
  }

  public async createOrderInstance (data: OrderInstance): Promise<OrderInstance> {
    // Remove unnecessary properties
    delete data.uuid
    delete data.status
    delete data.amount_paid

    const response = await this.http.post(`${this.endpoint}`, data)
    const responseData: OrderInstance = response.data
    return responseData
  }

  public async updateOrderInstance (data: OrderInstance): Promise<OrderInstance> {
    const uuid = data.uuid
    const orderNumber = data.number

    // Remove properties that aren't needed and can cause problems if edited
    // The only things editable in an order are:
    // - status
    // - tracking_number
    delete data.uuid
    delete data.number
    delete data.date
    delete data.total
    delete data.products
    delete data.customer_info
    delete data.shipping_address
    delete data.billing_address
    delete data.is_paid
    delete data.amount_paid

    const response = await this.http.post(`${this.endpoint}/${uuid}`, data)
    const responseData: OrderInstance = response.data
    this.app.$bvToast.toast(
      'Pedido Editado con Éxito', {
        title: `Pedido #${orderNumber}`,
        variant: 'success',
        autoHideDelay: 5000
      }
    )
    return responseData
  }
}
